import React, { createContext, useContext, useEffect, useRef, useState } from 'react';

type OverlayLoaderContextType = {
  isLoading: boolean;
  message: string;
  showLoader: (msg?: string) => void;
  hideLoader: () => void;
};
const OverlayLoaderContext = createContext<OverlayLoaderContextType | undefined>(undefined);

export const OverlayLoaderProvider = ({ children }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('Loading...');

  const showLoader = (msg = 'Loading...') => {
    setMessage(msg);
    setIsLoading(true);
  };
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setIsLoading(false);
    }, 10 * 1000);

    return () => {
      // Cleanup timeout on unmount
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const hideLoader = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsLoading(false);
  };
  return (
    <OverlayLoaderContext.Provider value={{ isLoading, message, showLoader, hideLoader }}>
      {children}
    </OverlayLoaderContext.Provider>
  );
};

export const useOverlayLoader = () => {
  const context = useContext(OverlayLoaderContext);
  if (!context) {
    throw new Error('useOverlayLoader must be used within an OverlayLoaderProvider');
  }
  return context;
};
